import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { boltIcon, hoverViewWrapper } from "../styles_vanilla.css";
import { STATUS_CONFIG, DEFAULT_CONTENT } from "./config";
import {
  editIcon,
  pendingUpdateText,
  addIcon,
  addIconDisabled,
  externalLinkIcon,
  userIconWrapper,
  userIcon,
} from "./styles_vanilla.css";
import { PaymentBeneficiaryStatusProps, InitialIconProps, ViewLinkProps } from "./types";

const InitialIcon: React.FC<InitialIconProps> = ({ type, variant }) => {
  if (type === "user") {
    return (
      <Flex className={userIconWrapper}>
        <Icon type={type} variant={variant} className={userIcon} data-testid="user-icon" />
      </Flex>
    );
  }
  return <Icon type={type} variant={variant} className={boltIcon} data-testid="bolt-icon" />;
};

const ViewLink: React.FC<ViewLinkProps> = ({ showViewLink, onEditClick }) => {
  if (!showViewLink) return null;

  return (
    <Flex className={hoverViewWrapper} onClick={onEditClick} style={{ cursor: "pointer" }}>
      <Icon type="edit" className={editIcon} data-testid="edit-icon" />
    </Flex>
  );
};

export const PaymentBeneficiaryStatus: React.FC<PaymentBeneficiaryStatusProps> = ({
  status,
  content,
  onEditClick,
  onAddClick,
}) => {
  const config = STATUS_CONFIG[status];
  const displayContent = config.text.content || content || DEFAULT_CONTENT;

  return (
    <Flex className={config.containerClass} onClick={addIconDisabled ? onAddClick : undefined}>
      {config.showInitialIcon && config.initialIconType && (
        <InitialIcon type={config.initialIconType} variant={config.initialIconVariant} />
      )}

      {config.showAddIcon && (
        <Icon
          type="plus"
          className={status === "add-payment-disabled" ? addIconDisabled : addIcon}
          data-testid="plus-icon"
        />
      )}

      <Text className={config.text.className}>{displayContent}</Text>

      {config.showPendingText && (
        <Text className={pendingUpdateText}>Update pending approval</Text>
      )}

      <ViewLink showViewLink={config.showViewLink ?? false} onEditClick={onEditClick} />

      {config.showExternalLink && (
        <Icon
          type="external-link"
          className={externalLinkIcon}
          data-testid="external-link-icon"
        />
      )}
    </Flex>
  );
};
